import type { ReactNode } from "react";

interface FilterSectionProps {
  title: string;
  children: ReactNode;
}

export default function FilterSection({ title, children }: FilterSectionProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-label-sm content-base-primary">{title}</span>
      {children}
    </div>
  );
}
